import { Options } from "common";
import api from "app/api";
import { ROLES } from "app/constants";

export interface SubmitListItem {
  id: number;
  email: string;
}
export interface SubmitFormItem {
  party_id?: number;
  auth_key: string;
  created_at: number;
  email: string;
  email_verified: number; //boolean
  first_name: string;
  id: number;
  last_name: string;
  password_hash: string;
  password_reset_token?: string;
  phone?: string;
  role: ROLES;
  sf_id?: number;
  status: number;
  timezone: string;
  updated_at: number;
  username: string;
  verify_token?: string;
}

export type SubmitOptions = Options<"group" | "status" | "role">;

export function getSubmitService() {
  return api.getService<SubmitFormItem, SubmitListItem, SubmitOptions>(
    "submits"
  );
}

export function getSubmitLimit() {
  return api.get(`/submits/limit`);
}